<div class="relative flex flex-col flex-auto w-full min-h-0">
  <div
    *ngIf="isAdminEspacePartenaire"
    class="fixed inset-x-0 top-0 flex h-10 items-center justify-center overflow-hidden px-4 text-sm font-semibold text-amber-950 bg-amber-300 border-b border-amber-400 shadow-sm whitespace-nowrap print:hidden"
    style="z-index: 1000"
    role="status"
  >
    <span class="block overflow-hidden text-ellipsis text-center">
      Vous êtes connecté avec le rôle Admin Espace Partenaire
      <ng-container *ngIf="adminEspacePartenaireCompanyName">
        — {{ adminEspacePartenaireCompanyName }}
      </ng-container>
    </span>
  </div>
  <div
    class="flex flex-auto w-full min-h-0"
    [style.padding-top.px]="isAdminEspacePartenaire ? 40 : 0"
  >
    <router-outlet></router-outlet>
  </div>
</div>
